
import { useEffect, useState } from 'react'
import { useLang } from '../../../_metronic/i18n/Metronici18n'
import { useIntl } from 'react-intl';
import { useAuth } from '../../modules/auth';
import Img1 from './BoxImgs/Img2.png'
import { getDahboardInfo } from '../applicationuser/list/core/_requests';

const AdminInfoBox = () => {


    const lang = useLang()
    const intl = useIntl();
    const { currentUser } = useAuth();
    const [boxData, setBoxData]: any = useState([]);


    useEffect(() => {
        getDahboardInfo().then((res: any) => {
        
            setBoxData(res)
        })
    }, [])


    return (

        <div className='d-flex row px-2'>
            <div className='col-sm-4  col-12'>
                <div
                    className="card bgi-no-repeat card-xl-stretch mb-xl-8  "
                    style={{
                        backgroundPosition: 'right top',
                        backgroundSize: '30%',
                        backgroundImage: `url(${Img1})`
                    }}
                >
                    <div className="card-body p-5">
                        <a href="#" className="card-title fw-bold text-muted text-hover-primary fs-4">
                            {intl.formatMessage({ id: 'Kayıt_Sayisi' })}
                        </a>
                        <div className="fw-bold text-primary my-3 ">
                            {lang === "tr" ? boxData?.activePeriodName
                                : boxData?.activePeriodNameEn}

                        </div>
                        <p className="text-primary fw-bold   fs-1 m-0">
                            {boxData?.registeredUsersCount}
                        </p>
                    </div>
                </div>
            </div>
            <div className='col-sm-4  col-12'>
                <div
                    className="card bgi-no-repeat card-xl-stretch mb-xl-8 "
                    style={{
                        backgroundPosition: 'right top',
                        backgroundSize: '30%',
                        backgroundImage: `url(${Img1})`
                    }}
                >
                    <div className="card-body p-5">
                        <a href="#" className="card-title fw-bold text-muted text-hover-primary fs-4">
                            {intl.formatMessage({ id: 'Tercih_Sayisi' })}
                        </a>
                        <div className="fw-bold text-primary my-3 ">{lang === "tr" ? boxData?.activePeriodName
                            : boxData?.activePeriodNameEn}</div>
                        <p className="text-primary fw-bold   fs-1 m-0">
                            {boxData?.preferenceCount}
                        </p>
                    </div>
                </div>
            </div>
            <div className='col-sm-4  col-12 '>
                <div
                    className="card bgi-no-repeat card-xl-stretch mb-xl-8 "
                    style={{
                        backgroundPosition: 'right top',
                        backgroundSize: '30%',
                        backgroundImage: `url(${Img1})`
                    }}
                >
                    <div className="card-body p-5">
                        <a href="#" className="card-title fw-bold text-muted text-hover-primary fs-4">
                            {intl.formatMessage({ id: 'Yerlesen_Sayisi' })}
                        </a>
                        <div className="fw-bold text-primary my-3 ">{lang === "tr" ? boxData?.activePeriodName
                            : boxData?.activePeriodNameEn}</div>
                        <p className="text-primary fw-bold   fs-1 m-0">
                            {boxData?.placementCount}
                        </p>
                    </div>
                </div>
            </div>
        </div>

    )
}



export { AdminInfoBox }
